import { React, useEffect, useState } from "react";
import TabContent from "../../../../layout/Tabs/TabContent";
import TabHeader from "../../../../layout/Tabs/TabHeader";
import TabBody from "../../../../layout/Tabs/TabBody";
import TabLink from "../../../../layout/Tabs/TabLink";
import CompanyForm from "@serie3/freelancesplaceapi/Form/Crm/CompanyForm";
import { useFormik } from "formik";
import { useParams } from "react-router-dom";
import { Row, Col } from "react-bootstrap";
import crudApi from "@serie3/common/api/crudApi";
import Contacts from "../Shared/Components/Contacts";
import Media from "../Shared/Components/Media";
import {
  faPhone,
  faHouse,
  faHashtag,
  faComment,
  faBuilding,
  faPencil,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import SaveButton from "../../../../layout/Buttons/SaveButton";
import CompanyBasicsForm from "./CompanyBasicsForm";
import NewModal from "../../documents/modals/NewModal";
import CustomModal from "../../../../layout/CustomModal";
import Adresses from "../Shared/Components/Addresses";
import Comments from "../Shared/Components/Comments";
import Content from "../../../../layout/Content";
import ContentHeader from "../../../../layout/ContenteHeader";
import AiResearchButton from "../Shared/AiResearchButton";

const InfoRow = ({ label, value }) => {
  if (!value) return null;
  return (
    <div style={{
      display: "flex", justifyContent: "space-between", alignItems: "center",
      padding: "10px 0", borderBottom: "1px solid #f0f0f0",
    }}>
      <span style={{ fontSize: "0.78rem", fontWeight: 600, color: "#9e9e9e", textTransform: "uppercase", letterSpacing: "0.05em" }}>
        {label}
      </span>
      <span style={{ fontSize: "0.88rem", fontWeight: 600, color: "#424242" }}>
        {value}
      </span>
    </div>
  );
};

const Edit = () => {
  const [isLoaded, setIsLoaded] = useState(false);
  const [company, setCompany] = useState();
  const [contactData, setContactData] = useState();
  const [mediaData, setMediaData] = useState();
  const [addressData, setAddressData] = useState();
  const [commentsData, setCommentsData] = useState();
  const [showEdit, setShowEdit] = useState(false);
  const [dupCompany, setDupCompany] = useState(null);
  const prefix = "crm-company";
  const formik = useFormik({
    ...CompanyForm.createCompanyForm(),
    onSubmit: async (values) => {
      const response = await crudApi.edit("/crm/company/edit", JSON.stringify(values, null, 2));
      if (response.status === 409) {
        setDupCompany(response.data?.existing ?? response.data);
      }
    },
  });
  let { id } = useParams();

  const loadData = async (id) => {
    const company = await crudApi.show("/crm/company/show/", id);
    setCompany(company);
    setContactData(company.kontaktdaten);
    setMediaData(company.soziale_medien);
    setAddressData(company.adresse);
    setCommentsData(company.kommentare);
    formik.setValues(CompanyForm.setEditData(company));
    setIsLoaded(true);
  };

  useEffect(() => {
    loadData(id);
  }, [id]);

  const handleSave = (e) => {
    formik.handleSubmit(e);
    e.preventDefault();
  };

  const forceSubmit = async () => {
    const values = { ...formik.values, forced: true };
    await crudApi.edit("/crm/company/edit", JSON.stringify(values, null, 2));
    setDupCompany(null);
    setShowEdit(false);
  };

  const SaveBasicsButton = () => (
    <SaveButton handleClick={(e) => { handleSave(e); setShowEdit(false); }} />
  );

  const companyName = formik.values.firmenname || "Company";
  const rechtsform = formik.values.rechtsform;
  const kundenklasse = formik.values.kundenklasse;
  const gesperrt = formik.values.gesperrt;
  const sperrgrund = formik.values.sperrgrund;
  const initials = companyName.split(" ").map(w => w[0]).slice(0, 2).join("").toUpperCase();
  const title = () => companyName;

  return !isLoaded ? null : (
    <>
      <NewModal show={showEdit} setShow={setShowEdit} ExtraButton={SaveBasicsButton}>
        <CompanyBasicsForm formik={formik} />
      </NewModal>

      <CustomModal show={!!dupCompany} setShow={() => setDupCompany(null)} title="Company already exists">
        <div style={{ padding: "24px" }}>
          <div style={{ fontSize: "0.85rem", color: "#616161", marginBottom: "16px" }}>
            The following company was found. Save as duplicate anyway?
          </div>

          <div style={{ background: "#f8f9fb", borderRadius: "10px", padding: "14px 16px", marginBottom: "14px", border: "1px solid #e0e0e0" }}>
            <div style={{ fontWeight: 800, fontSize: "1rem", color: "#212121", marginBottom: "2px" }}>{dupCompany?.firmenname}</div>
            {dupCompany?.rechtsform && <div style={{ fontSize: "0.78rem", color: "#1a73e8", marginBottom: "6px" }}>{dupCompany.rechtsform}</div>}
            {dupCompany?.kundenklasse && <div style={{ fontSize: "0.78rem", color: "#616161" }}>Class: {dupCompany.kundenklasse}</div>}
          </div>

          {dupCompany?.adresse?.length > 0 && (
            <div style={{ marginBottom: "12px" }}>
              <div style={{ fontSize: "0.68rem", fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.07em", color: "#9e9e9e", marginBottom: "6px" }}>Addresses</div>
              {dupCompany.adresse.map((a, i) => (
                <div key={i} style={{ fontSize: "0.82rem", color: "#424242", padding: "4px 0", borderBottom: "1px solid #f0f0f0" }}>
                  {[a.strasse, a.hausnummer, a.plz, a.ort].filter(Boolean).join(" ")}
                  {a.title && <span style={{ color: "#9e9e9e", marginLeft: "6px" }}>· {a.title}</span>}
                </div>
              ))}
            </div>
          )}

          {dupCompany?.kontaktdaten?.length > 0 && (
            <div style={{ marginBottom: "12px" }}>
              <div style={{ fontSize: "0.68rem", fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.07em", color: "#9e9e9e", marginBottom: "6px" }}>Contact</div>
              {dupCompany.kontaktdaten.map((c, i) => (
                <div key={i} style={{ fontSize: "0.82rem", color: "#424242", padding: "4px 0", borderBottom: "1px solid #f0f0f0" }}>
                  <span style={{ color: "#9e9e9e", marginRight: "6px" }}>{c.key_name}:</span>{c.value}
                </div>
              ))}
            </div>
          )}

          {dupCompany?.soziale_medien?.length > 0 && (
            <div style={{ marginBottom: "20px" }}>
              <div style={{ fontSize: "0.68rem", fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.07em", color: "#9e9e9e", marginBottom: "6px" }}>Social Media</div>
              {dupCompany.soziale_medien.map((s, i) => (
                <div key={i} style={{ fontSize: "0.82rem", color: "#424242", padding: "4px 0", borderBottom: "1px solid #f0f0f0" }}>
                  <span style={{ color: "#9e9e9e", marginRight: "6px" }}>{s.key_name}:</span>{s.value}
                </div>
              ))}
            </div>
          )}

          <div style={{ display: "flex", gap: "10px" }}>
            <button type="button" onClick={() => setDupCompany(null)}
              style={{ padding: "9px 20px", border: "none", borderRadius: "10px", background: "#f5f5f5", color: "#616161", fontWeight: 600, fontSize: "0.88rem", cursor: "pointer" }}>
              Cancel
            </button>
            <button type="button" onClick={forceSubmit}
              style={{ padding: "9px 20px", border: "none", borderRadius: "10px", background: "#e53935", color: "#fff", fontWeight: 600, fontSize: "0.88rem", cursor: "pointer" }}>
              Save anyway
            </button>
          </div>
        </div>
      </CustomModal>

      <ContentHeader>
        <div style={{ display: "flex", alignItems: "center", gap: "14px" }}>
          <div style={{
            width: "46px", height: "46px", borderRadius: "12px",
            background: "linear-gradient(135deg, #1a73e8 0%, #1a237e 100%)",
            color: "#fff", display: "flex", alignItems: "center", justifyContent: "center",
            fontSize: "1.2rem", flexShrink: 0, boxShadow: "0 4px 12px rgba(26,115,232,0.3)",
          }}>
            <FontAwesomeIcon icon={faBuilding} />
          </div>
          <div>
            <div style={{ fontSize: "1.5rem", fontWeight: 800, color: "#212121", lineHeight: 1.2 }}>
              {companyName}
            </div>
            <div style={{ fontSize: "0.85rem", color: "#9e9e9e", marginTop: "2px" }}>
              CRM · Company
            </div>
          </div>
        </div>
      </ContentHeader>

      <Content Title={title}>
        <Row>
          <Col className="col-md-3">
            <div style={{
              background: "#fff", borderRadius: "16px",
              boxShadow: "0 2px 16px rgba(0,0,0,0.08)",
              overflow: "hidden", marginBottom: "16px",
            }}>
              {/* Top banner + avatar */}
              <div style={{
                height: "72px",
                background: "linear-gradient(135deg, #1a73e8 0%, #1a237e 100%)",
              }} />
              <div style={{ padding: "0 24px 24px", position: "relative" }}>
                <div style={{
                  width: "64px", height: "64px", borderRadius: "50%",
                  background: "linear-gradient(135deg, #1a73e8, #0d47a1)",
                  border: "3px solid #fff",
                  color: "#fff", display: "flex", alignItems: "center",
                  justifyContent: "center", fontWeight: 800, fontSize: "1.2rem",
                  marginTop: "-32px", marginBottom: "12px",
                  boxShadow: "0 4px 12px rgba(26,115,232,0.3)",
                }}>
                  {initials}
                </div>

                <div style={{ fontWeight: 800, fontSize: "1.05rem", color: "#212121", marginBottom: "2px" }}>
                  {companyName}
                </div>
                {rechtsform && (
                  <div style={{
                    display: "inline-block", fontSize: "0.72rem", fontWeight: 700,
                    padding: "2px 10px", borderRadius: "99px",
                    background: "#e8f0fe", color: "#1a73e8", marginBottom: "16px",
                  }}>
                    {rechtsform}
                  </div>
                )}

                <div style={{ marginBottom: "16px" }}>
                  <InfoRow label="Class" value={kundenklasse} />
                  {gesperrt && <InfoRow label="Blocked" value="Yes" />}
                  {gesperrt && <InfoRow label="Reason" value={sperrgrund} />}
                </div>

                <button
                  type="button"
                  onClick={() => setShowEdit(true)}
                  style={{
                    width: "100%", padding: "9px", border: "none",
                    borderRadius: "10px", fontWeight: 700, fontSize: "0.88rem",
                    background: "#f0f4ff", color: "#1a73e8", cursor: "pointer",
                    display: "flex", alignItems: "center", justifyContent: "center", gap: "7px",
                    transition: "background 0.15s",
                  }}
                  onMouseOver={e => e.currentTarget.style.background = "#dce8fd"}
                  onMouseOut={e => e.currentTarget.style.background = "#f0f4ff"}
                >
                  <FontAwesomeIcon icon={faPencil} style={{ fontSize: "0.75rem" }} />
                  Edit Basics
                </button>
                <div style={{ marginTop: "8px" }}>
                  <AiResearchButton
                    companyId={company.id}
                    formik={formik}
                    setContactData={setContactData}
                    setAddressData={setAddressData}
                    setMediaData={setMediaData}
                  />
                </div>
              </div>
            </div>
          </Col>

          <Col className="col-md-9">
            <div style={{
              background: "#fff", borderRadius: "16px",
              boxShadow: "0 2px 16px rgba(0,0,0,0.08)", overflow: "hidden",
            }}>
              <TabHeader prefix={prefix}>
                <TabLink prefix={prefix} name={"Comments"} icon={faComment} />
                <TabLink prefix={prefix} name={"Contact"} icon={faPhone} />
                <TabLink prefix={prefix} name={"Address"} icon={faHouse} />
                <TabLink prefix={prefix} name={"Media"} icon={faHashtag} />
              </TabHeader>
              <TabBody>
                <TabContent prefix={prefix} name={"Comments"} show={true}>
                  <Comments commentsData={commentsData} setCommentsData={setCommentsData} companyId={company.id} personId={null} />
                </TabContent>
                <TabContent prefix={prefix} name={"Contact"}>
                  <Contacts contactData={contactData} setContactData={setContactData} companyId={company.id} personId={null} />
                </TabContent>
                <TabContent prefix={prefix} name={"Address"}>
                  <Adresses addressData={addressData} setAddressData={setAddressData} companyId={company.id} personId={null} />
                </TabContent>
                <TabContent prefix={prefix} name={"Media"}>
                  <Media dataList={mediaData} setDataList={setMediaData} companyId={company.id} personId={null} />
                </TabContent>
              </TabBody>
            </div>
          </Col>
        </Row>
      </Content>
    </>
  );
};

export default Edit;
